var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-chip',{attrs:{"text":_vm.statusText(_vm.type),"color":_vm.statusColor(_vm.type),"iconLeft":_vm.statusIcon(_vm.type),"small":_vm.small}})
}
var staticRenderFns = []

export { render, staticRenderFns }